import TagBox from 'devextreme-react/tag-box';
import React, { useEffect, useState } from 'react';
import api from '../../../../services/api-configuration';

// Veri kapsamı — sahalar (040): narrows what the user sees on the scoped screens to cars now at these sites, on top of the
// company's scope or the "tüm firmaların verisi" role; empty = no narrowing. Saved with the form (custody/saveUserScope).
export default function SahaKapsami({ employeeId, value, setValue }) {
    const [sites, setSites] = useState([]);
    useEffect(() => {
        if (!employeeId) return;
        api.post('/custody/userScope', { employee_id: employeeId })
            .then((r) => { setSites(r.data.sites || []); setValue(r.data.site_ids || []); })
            .catch(() => setSites([]));
    }, [employeeId, setValue]);
    return (
        <div className="mt-2">
            <div className="mb-1" style={{ color: 'black' }}><b>Veri kapsamı — sahalar</b></div>
            <div className="text-muted mb-2" style={{ fontSize: 12 }}>
                Seçilirse kullanıcı Şase Sorgulama, Stok İzleme, Raporlar ve devir-teslim ekranlarında yalnızca bu sahalarda duran araçları görür
                (firmanın veri kapsamı veya "tüm firmaların verisi" rolü içinde). Boş = daraltma yok. Marka seçimi de aynı şekilde daraltır.
            </div>
            <TagBox dataSource={sites} valueExpr="id" displayExpr={(s) => (s ? `${s.name} (${s.code})` : '')} value={value || []}
                showSelectionControls applyValueMode="useButtons" placeholder="Tüm sahalar (daraltma yok)"
                onValueChanged={(e) => setValue(e.value)} />
        </div>
    );
}
